import React from 'react';

import { useSiteMetadata } from '../utils/useSiteMetadata';

export const Email = () => {
  const { email } = useSiteMetadata();

  return <a href={`mailto:${email}`}>{email}</a>;
};
